export default __webpack_public_path__ + "static/media/logo crispine.ae019a5a.png";